import { getFilmById, isEmptyArray, LoadingState } from '@vista/omnichannel-components-domain';
import { ShowtimePickerMessageType as MessageType } from '../../../subcomponents/showtime-picker/subcomponents/message';
import { nonFixedFiltersApplied } from '../../../subcomponents/showtime-picker/utils/showtime-picker-utils';
export const validateShowtimePickerData = (screeningDates, query, filmIdsToDisplay, filmsLoadingState, config) => {
    var _a, _b;
    let invalidStateMessage = undefined;
    const invalidStateMessageFilm = ((_a = query.filmIds) === null || _a === void 0 ? void 0 : _a.length) === 1 ? getFilmById(query.filmIds[0]) : undefined;
    if (!((_b = query.siteIds) === null || _b === void 0 ? void 0 : _b.length)) {
        invalidStateMessage = MessageType.NoCinemasSelected;
    }
    else if (screeningDates) {
        if (isEmptyArray(screeningDates)) {
            invalidStateMessage = MessageType.NoShowtimesAllDates;
        }
        else if (filmsLoadingState === LoadingState.Success && filmIdsToDisplay.length === 0) {
            if (nonFixedFiltersApplied(config.filter)) {
                invalidStateMessage = MessageType.NoShowtimesForFilter;
            }
            else {
                invalidStateMessage = config.filmDetails.show
                    ? MessageType.NoShowtimesForSitesOnDate
                    : MessageType.NoShowtimesForFilmOnDate;
            }
        }
    }
    return invalidStateMessage
        ? { messageType: invalidStateMessage, messageFilmTitle: invalidStateMessageFilm === null || invalidStateMessageFilm === void 0 ? void 0 : invalidStateMessageFilm.title }
        : undefined;
};
